document.addEventListener("DOMContentLoaded", function () {
  const variantSelects = document.querySelectorAll('select[name="options[]"], .product-form select');

  function updatePreorderState() {
    const variantIdInput = document.querySelector(".product-variant-id");
    const submitBtn = document.querySelector('[id^="ProductSubmitButton"]');
    const preorderMsg = document.querySelector(".preorder-message");

    if (!variantIdInput || !submitBtn) return;

    // Read variant data from JSON stored in theme
    const productJson = document.querySelector('[type="application/json"][data-product-json]');
    if (!productJson) return;

    const productData = JSON.parse(productJson.textContent);
    const currentVariant = productData.variants.find(v => v.id == variantIdInput.value);

    if (!currentVariant) return;

    // Inventory quantity may be null if “continue selling” is enabled, so treat null as 0
    const inventoryQty = currentVariant.inventory_quantity || 0;

    // If out of stock → Preorder mode
    if (inventoryQty <= 0) {
      submitBtn.disabled = false;
      submitBtn.querySelector('span').textContent = "Pre-Order Now";

      if (!preorderMsg) {
        const msg = document.createElement("p");
        msg.className = "preorder-message";
        msg.style.marginBottom = "12px";
        msg.style.color = "#cba300";
        msg.style.fontWeight = "bold";
        msg.textContent = "Pre-order now — estimated shipping in January.";
        submitBtn.parentNode.insertBefore(msg, submitBtn);
      }

    } else {
      // In stock → Normal add to cart
      submitBtn.disabled = false;
      submitBtn.querySelector('span').textContent = "Add to Cart";

      if (preorderMsg) preorderMsg.remove();
    }
  }

  // Listen to variant change
  variantSelects.forEach(select => {
    select.addEventListener("change", updatePreorderState);
  });

  // Run once on load
  updatePreorderState();
});
